import { DotsNine, List, MagnifyingGlass, MapPin, User } from '@phosphor-icons/react';
import { useState } from 'react';

import {
  ActionToolbar,
  LeftMenu,
  MaterialsTable,
  OrderHeader,
  SearchBar,
  TabNavigation,
} from 'external-quote/components';
import { externalQuoteTheme } from 'external-quote/styles';
import { IPartBom } from 'partBoms/types';

import {
  ContentContainer,
  HeaderContainer,
  HeaderLeft,
  HeaderRight,
  HeaderText,
  HeaderTitle,
  MainContainer,
  PageContainer,
  SearchBox,
  SearchIcon,
  SearchInput,
} from './styles';

export const ExternalQuotePage = () => {
  const [partBoms, setPartBoms] = useState<IPartBom[]>([]);
  const [selectedPartBomId, setSelectedPartBomId] = useState<number | null>(null);

  const handleAddItems = (partBom: IPartBom) => {
    setPartBoms((prevBoms) => [...prevBoms, partBom]);
    setSelectedPartBomId(null); // Reset after adding items
  };

  const handleBomButtonClick = (partBomId: number) => {
    setSelectedPartBomId(partBomId);
  };

  return (
    <PageContainer>
      <HeaderContainer>
        <HeaderLeft>
          <List size={18} color={externalQuoteTheme.colors.headerText} />
          <DotsNine size={18} weight="fill" color={externalQuoteTheme.colors.headerText} />
          <HeaderTitle>Quote and Order Entry</HeaderTitle>
        </HeaderLeft>

        <SearchBox>
          <SearchIcon>
            <MagnifyingGlass size={14} color={externalQuoteTheme.colors.headerText} />
          </SearchIcon>
          <SearchInput placeholder="Search" />
        </SearchBox>

        <HeaderRight>
          <HeaderText>SANDBOX</HeaderText>
          <MapPin size={18} color={externalQuoteTheme.colors.headerText} />
          <User size={18} color={externalQuoteTheme.colors.headerText} />
        </HeaderRight>
      </HeaderContainer>

      <MainContainer>
        <LeftMenu />

        <ContentContainer>
          <ActionToolbar />
          <OrderHeader />
          <TabNavigation />
          <SearchBar
            onAddItems={handleAddItems}
            partBomId={selectedPartBomId}
            onCloseIframe={() => setSelectedPartBomId(null)}
          />
          <MaterialsTable partBoms={partBoms} onBomButtonClick={handleBomButtonClick} />
        </ContentContainer>
      </MainContainer>
    </PageContainer>
  );
};
